/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import useTranslator from '../translations';
import TranslationIds from '../translationIds';
import useUIStates from '../../store/models/uistates/useUIStates';

function useTranslatedLabels () {

    const [instructions, setInstructions] = useState('');
    const {
        deviceInfo,
    } = useUIStates();

    const  {
        translateWithValues,
    } = useTranslator();

    useEffect(() => {
        const instValues = {
            calapp: deviceInfo.dataPlatform,
            b: (text) => <b>{text}</b> ,
        }
        const inst = translateWithValues(TranslationIds.CALENDAR_PROC_INSTRUCTIONS, instValues);
        setInstructions(inst);
    }, [deviceInfo]);
        
    return {
        instructions,
    };
}

export default useTranslatedLabels;
